import { GestationalAge } from "../GestationalAge";
import { OntarioObstetricalPostnatalDiscussionTopics } from "./Postnatal/OntarioObstetricalPostnatalDiscussionTopics";
import { OntarioObstetricalPostNatalHistory } from "./Postnatal/OntarioObstetricalPostNatalHistory";
import { OntarioObstetricalPostnatalPhysicalExam } from "./Postnatal/OntarioObstetricalPostnatalPhysicalExam";

class OntarioObstetricalFileFormPostnatal {
    public DateOfVisit?: Date;
    public DateOfDelivery?: Date;
    public NumberOfWeeksPostPartum: number;
    public GestationalAgeAtBirth: GestationalAge;
    public History: OntarioObstetricalPostNatalHistory;
    public PhysicalExamAsIndicated: OntarioObstetricalPostnatalPhysicalExam;
    public DiscussionTopics: OntarioObstetricalPostnatalDiscussionTopics;
    public HealthProviderSignature: string;

    public constructor(fields?: Partial<OntarioObstetricalFileFormPostnatal>) {
        Object.assign(this, fields);
        this.GestationalAgeAtBirth = new GestationalAge(fields?.GestationalAgeAtBirth);
        this.PhysicalExamAsIndicated = new OntarioObstetricalPostnatalPhysicalExam(fields?.PhysicalExamAsIndicated);
        this.History = new OntarioObstetricalPostNatalHistory(fields?.History);
        this.DiscussionTopics = new OntarioObstetricalPostnatalDiscussionTopics(fields?.DiscussionTopics);
    }
}

export { OntarioObstetricalFileFormPostnatal };
